<template>
  <div
    class="accessory"
    :id="`option-accessory-${accId}`"
    :class="{ included: isIncluded }"
    :style="alwaysOn ? { display: 'none' } : {}"
  >
    <div class="content">
      <header>
        <h5 :class="{ supplanted: includedAccSupplanted() }">
          {{ acc.title }}
          <span
            v-if="
              $store.state.accessories[accId] &&
              $store.state.accessories[accId].showInScene
            "
            class="3d-icon"
            v-on:mouseover="positionTooltip"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="3d-icon-svg"
              width="24"
              height="24"
              viewBox="0 0 18 10"
            >
              <g
                id="eye-icon-dark"
                style="mix-blend-mode: normal; isolation: isolate"
              >
                <path
                  id="eye-icon-dark-2"
                  data-name="eye-icon-dark"
                  d="M8.5-20q4.174,0,8.5,4.9-1.025,1.025-1.309,1.29t-1.385,1.176a10.29,10.29,0,0,1-1.783,1.252,14.7,14.7,0,0,1-1.8.721,6.882,6.882,0,0,1-2.22.379A8.689,8.689,0,0,1,6-10.627,7.533,7.533,0,0,1,3.719-11.8a22.359,22.359,0,0,1-1.783-1.423Q1.29-13.815,0-15.143A25.961,25.961,0,0,1,4.383-18.8,7.641,7.641,0,0,1,8.5-20ZM6.09-12.714A3.257,3.257,0,0,0,8.5-11.69a3.257,3.257,0,0,0,2.41-1.025,3.35,3.35,0,0,0,1.006-2.429,3.35,3.35,0,0,0-1.006-2.429A3.257,3.257,0,0,0,8.5-18.6a3.257,3.257,0,0,0-2.41,1.025,3.35,3.35,0,0,0-1.006,2.429A3.35,3.35,0,0,0,6.09-12.714ZM8.5-16.357a1.182,1.182,0,0,0,.342.873,1.182,1.182,0,0,0,.873.342,1.317,1.317,0,0,0,.759-.266v.266A1.971,1.971,0,0,1,9.9-13.72a1.877,1.877,0,0,1-1.4.588,1.877,1.877,0,0,1-1.4-.588,1.971,1.971,0,0,1-.569-1.423A1.971,1.971,0,0,1,7.1-16.566a1.877,1.877,0,0,1,1.4-.588h.3A1.258,1.258,0,0,0,8.5-16.357Z"
                  transform="translate(0 20)"
                  fill="#a4b1be"
                />
              </g>
            </svg>
            <span class="tooltip"
              >{{ epEmail }}
              <div class="carrot"></div
            ></span>
          </span>
        </h5>
        <button v-on:click="showAccessoryPopup()" v-if="getT">
          {{
            getT.static.customizer[0].options_container[0].accessory_list[0]
              .accessory_template[0].learn_more_button_text
          }}
        </button>
      </header>
      <div
        class="toggle"
        v-on:click="
          !isIncluded && toggleAccessory();
          $event.stopPropagation();
        "
      >
        <button aria-label="Toggle Accessory" :disabled="isIncluded">
          <img
            v-if="
              (isIncluded && !includedAccSupplanted()) ||
              $store.state.selectedAccessories.includes(accId)
            "
            src="./../../assets/icons/checkbox-selected.svg"
          />
          <img v-else src="./../../assets/icons/checkbox-deselected.svg" />
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { breakpoint } from '../../styles/style';
import { mapGetters } from 'vuex';

export default {
  name: 'Accessory',
  props: ['accId', 'acc', 'isIncluded'],
  methods: {
    includedAccSupplanted() {
      // some included accessories are not always included
      return (
        this.accId == 'manual-security-cover' && this.manualCoverIsDisabled
      );
    },
    showAccessoryPopup() {
      let domAcc = document.querySelector(`#option-accessory-${this.accId}`);
      let bounds = domAcc.getBoundingClientRect();
      let popupArticle = document.querySelector(
        '#accessory-popup-wrap article'
      );
      let popupVideo = document.querySelector(
        '#accessory-popup-wrap .in-action video'
      );
      this.$store.commit('showAccessoryPopup', {
        accName: this.accId,
        isIncluded: this.isIncluded,
      });
      if (popupVideo) {
        popupVideo.pause();
        popupVideo.load();
        popupVideo.onload = () => {
          popupVideo.play();
        };
      }
      if (
        this.$store.state.animations &&
        document.body.clientWidth <= breakpoint.xl
      ) {
        // Mobile
        popupArticle.style.top = `${bounds.top}px`;
        setTimeout(() => {
          let popup = document.querySelector('#accessory-popup-wrap');
          popup.classList.remove('hidden');
          popup.classList.add('transitions');
          popupArticle.style.top = 'calc(55% - 4em)';
          popup.classList.remove('mini');
          popup.classList.add('show');
        }, 50);
        setTimeout(() => {
          popupArticle.style = '';
        }, 500);
        setTimeout(() => {
          let popup = document.querySelector('#accessory-popup-wrap');
          popup.classList.remove('show');
          popup.classList.remove('transitions');
        }, 1000);
      } else {
        // Desktop
        setTimeout(() => {
          let popup = document.querySelector('#accessory-popup-wrap');
          popup.classList.remove('mini');
          popup.classList.remove('hidden');
        }, 50);
      }
      // track event for Google Analytics
      this.$gtag.event('Learn More Clicked for ' + this.acc.title, {
        event_category: 'Learn More Click',
        event_label: 'Learn More Clicked for ' + this.acc.title,
        //selected_pool is not passed in the data layer because it's not relevant. A water treadmill, for example, is always the same thing regardless of the pool
      });
    },
    // checks if there is a conflict between an accessory to be selected and already selected accessories
    selectedAccConflict(accId) {
      const selectedAccessories = this.$store.state.selectedAccessories;
      const selectedPoolId = this.currPool.tag;

      // if it was already selected then the user is deselecting it so don't worry.
      if (this.$store.state.selectedAccessories.includes(accId)) {
        return false;
      }

      /*
        dualprop is special when it comes to accessory conflicts.
        it has 2 swim currents so there are 2 spots for accessories that are meant to be in the current. 
        other pools have 1 swim current.
      */
      if (selectedPoolId === 'dualprop') {
        if (accId === 'swim-mirror' || accId === 'mirror') {
          // if both of these are already selected then the new one conflicts
          return (
            selectedAccessories.includes('aqua-bike') &&
            selectedAccessories.includes('treadmill')
          );
        } else if (accId === 'treadmill') {
          // if two of these are already selected then the new one conflicts
          return (
            selectedAccessories.includes('aqua-bike') &&
            (selectedAccessories.includes('mirror') ||
              selectedAccessories.includes('swim-mirror'))
          );
        } else if (accId === 'aqua-bike') {
          // if two of these are already selected then the new one conflicts
          return (
            selectedAccessories.treadmill &&
            (selectedAccessories.includes('mirror') ||
              selectedAccessories.includes('swim-mirror'))
          );
        }
      } else {
        // for any of the other pools
        // return boolean for if we're dealing with any of the conflict combinations
        return (
          (accId === 'mirror' && selectedAccessories.includes('treadmill')) ||
          (accId === 'mirror' && selectedAccessories.includes('aqua-bike')) ||
          (accId === 'swim-mirror' &&
            selectedAccessories.includes('treadmill')) ||
          (accId === 'treadmill' &&
            selectedAccessories.includes('aqua-bike')) ||
          (accId === 'treadmill' && selectedAccessories.includes('mirror')) ||
          (accId === 'treadmill' &&
            selectedAccessories.includes('swim-mirror')) ||
          (accId === 'aqua-bike' &&
            selectedAccessories.includes('treadmill')) ||
          (accId === 'aqua-bike' && selectedAccessories.includes('mirror'))
        );
      }
    },
    /* 
      Try to toggle selection of accessory (possibly will prompt user about conflict decision).
      This method calls itself, recursively, for related accessories.
    */
    toggleAccessory(
      accId = this.accId,
      newRequestedSelectionValue = !this.$store.state.selectedAccessories.includes(
        this.accId
      ),
      trace = [],
      level = 0
    ) {
      let acc = this.$store.state.accessories[accId];

      // check for conflict between accessories.
      // if there is a conflict, the user can choose to select or not.
      let conflict = false;
      if (this.selectedAccConflict(accId)) {
        conflict = true;

        const notice = this.getT
          ? this.getT.static.accessory_conflict[0].accessory_conflict_notice
          : '';
        const question = this.getT
          ? this.getT.static.accessory_conflict[0].accessory_conflict_question +
            ' ' +
            acc.title +
            '?'
          : '';

        // trigger conflict popup, pass it callback
        this.accessoryConflict(notice, question, (result) => {
          // set in state
          this.$store.commit(
            `${result ? 'select' : 'deselect'}Accessory`,
            accId
          );
          // Hide popup
          this.$store.commit('hideAccessoryConflict');
        });
      }

      /* 
        there's no conflict, and we're not processing an accessory that was already processed,
        so go ahead and toggle it.
      */
      if (!trace.includes(accId) && !conflict) {
        // Avoid cycle
        trace.push(accId);

        // Set accessory as selected or not, in state
        try {
          this.$store.commit(
            `${newRequestedSelectionValue ? 'select' : 'deselect'}Accessory`,
            accId
          );
        } catch (err) {
          console.log(err);
        }

        // related accessories stuff:

        // Turn On: Also turn ON when this accessory turns on
        if (
          newRequestedSelectionValue &&
          acc.turn_on &&
          acc.turn_on.length > 0
        ) {
          this.toggleRelatedAccessories(true, acc.turn_on, trace, level);
        }

        // Turn Off: Also turn OFF when this accessory turns off
        if (
          !newRequestedSelectionValue &&
          acc.turn_off &&
          acc.turn_off.length > 0
        ) {
          this.toggleRelatedAccessories(false, acc.turn_off, trace, level);
        }

        // Unique: Turn OFF when this accessory turns on
        if (newRequestedSelectionValue && acc.unique && acc.unique.length > 0) {
          this.toggleRelatedAccessories(false, acc.unique, trace, level);
        }

        // Show info popup for automatic cover, if user is selecting it and manual is included in package
        if (
          accId === 'automatic-security-cover' &&
          this.manualCoverIsDisabled
        ) {
          const text = this?.getT.static.cover_upgrade_popup;
          this.$store.commit('showInfoPopup', text);
        }
      }
      // track event for Google Analytics
      this.$gtag.event('Accessory Checkbox Toggled for ' + this.acc.title, {
        event_category: 'Accessory Checkbox Toggle',
        event_label: 'Accessory Checkbox Toggled for ' + this.acc.title,
        selected_pool: this.currPool.title,
      });
    },
    // Toggle related accessories
    toggleRelatedAccessories(tryToSelect, arrOfRelatedAccIds, trace, level) {
      if (arrOfRelatedAccIds) {
        for (var accId of arrOfRelatedAccIds) {
          this.toggleAccessory(accId, tryToSelect, trace, level + 1);
        }
      }
    },
    accessoryConflict(notice, question, cb) {
      this.$store.commit('accessoryConflict', { notice, question, cb });
    },
    positionTooltip(evt) {
      const parent = evt.target.parentElement.parentElement;
      const tooltip = parent.querySelector('.tooltip');
      const icon = parent.querySelector('svg');
      if (tooltip && icon) {
        const carrot = tooltip.querySelector('div.carrot');
        const right = window.innerWidth - icon.getBoundingClientRect().right;
        if (right < 240) {
          // Right-align
          tooltip.style.right = '-5em';
          tooltip.style.left = 'unset';
          carrot.style.right = '4.6em';
          carrot.style.left = 'unset';
        } else {
          // Left-align
          tooltip.style.left = '-1.4em';
          tooltip.style.right = 'unset';
          carrot.style.left = '.6em';
          carrot.style.right = 'unset';
        }
      } else {
        console.error("Can't find tooltip to position.");
      }
    },
  },
  watch: {
    // Added flow to hide accessories that are always on but not toggleable by user, this activates them after model is loaded
    '$store.state.isLoading': {
      handler(newVal, oldVal) {
        if (this.alwaysOn && !newVal && oldVal && !this.active) {
          this.$store.commit('showHiddenAccessory', this.accId);
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters([
      'getT',
      'currPool',
      'selections',
      'showInfoPopup',
      'currPool',
      'manualCoverIsDisabled',
    ]),
    active: function () {
      return this.$store.state.selectedAccessories.includes(this.accId);
    },
    alwaysOn: function () {
      /*
          This was written as a solution for client requesting LED accessory for E line pools always be activated and 
          not be listed in the options menu. Later disused when E line models were redone. 
          'always_on_hidden' property can be used for an accessory in accessoryData.js like this:
            always_on_hidden: [...swim_spa_e]
      */
      const model = this.currPool.tag;
      const acc = this.$store.state.accessories[this.accId];
      return (
        acc &&
        acc.always_on_hidden &&
        acc.always_on_hidden.length &&
        acc.always_on_hidden.includes(model)
      );
    },
    epEmail: function () {
      const epe =
        this.getT?.static?.customizer[0]?.options_container[0]
          ?.accessory_list[0]?.accessory_template[0]?.tooltip;
      return (
        epe || 'This accessory will be visible in the 3D scene when selected.'
      );
    },
  },
};
</script>
<style scoped lang="scss">
.accessory {
  line-height: normal;
  border-bottom: 1px solid $deep-slate;
  &.included {
    .toggle button {
      opacity: 0.35;
      cursor: default;
      user-select: none;

      &:hover img {
        background-color: transparent;
      }
    }
  }
  .content {
    display: flex;
    justify-content: space-between;
    button {
      padding: 0.1em;
      background-color: transparent;
      text-transform: unset;
      border: none;
    }
    header {
      padding: 1em;
      h5 {
        color: white;
        // 3D icon
        span {
          position: absolute;
          margin-left: 0.5em;
          margin-top: -0.4em;
          display: inline-block;
          width: 10px;
          height: 10px;
          svg {
            transform: scale(0.65) translate(-0.6em, 0.55em);
            path,
            circle {
              stroke: lighten($slate, 10%);
            }
          }
          .tooltip {
            position: absolute;
            top: -5em;
            right: -5em;
            width: auto;
            height: auto;
            min-width: 20em;
            display: none;
            padding: 0.5em;
            font-size: 0.6rem;
            line-height: 0.7rem;
            color: white;
            background-color: #3e3e3e;
            text-transform: unset;
            div.carrot {
              content: '';
              display: block;
              position: absolute;
              bottom: -0.8em;
              right: 4em;
              width: 0;
              height: 0;
              border-right: 8px solid transparent;
              border-left: 8px solid transparent;
              border-top: 8px solid #3e3e3e;
            }
          }
          svg:hover + .tooltip,
          .tooltip:hover {
            display: block;
            animation: fade-up 600ms ease-out;
            @keyframes fade-up {
              0% {
                opacity: 0;
                transform: translateY(1em);
              }
              50% {
                opacity: 0;
                transform: translateY(1em);
              }
              100% {
                opacity: 1;
                transform: translateY(0em);
              }
            }
          }
        }
        &.supplanted {
          opacity: 0.5;
        }
      }
      button {
        font-size: 0.875rem;
        color: $muted-white;
        text-decoration: underline;
        &:hover {
          color: white;
        }
      }
    }
    .toggle {
      display: flex;
      align-items: center;
      padding-left: 1em;
      button {
        width: 1.7em;
        height: 1.7em;
        margin: 1em;
        display: flex;
        justify-content: center;
        img {
          width: 100%;
          height: 100%;
          &:hover {
            background-color: rgba(255, 255, 255, 0.1);
          }
        }
      }
    }
  }
}
</style>
